import React from 'react';

import { Image } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography, TypographyProps, withTypography } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, spacing } from 'styles/constants';

type OfferBadgeProps = React.PropsWithChildren<BoxProps>;

const styles = StyleSheet.create({
  offerContainer: {
    backgroundColor: getDesignToken('background-pattern'),
    borderColor: 'transparent',
    borderRadius: 10,
    borderWidth: 0,
    marginBottom: spacing.$4,
    padding: spacing.$1,
  },
  offerItem: {
    backgroundColor: 'transparent',
    borderRadius: 10,
    padding: spacing.$1,
    paddingTop: spacing.$3,
  },
  headerBkAndWalmart: {
    marginTop: spacing.$0,
  },
  headerReadySavings: {
    marginHorizontal: spacing.$4,
    marginTop: spacing.$0,
  },
  linkRoyalText: {
    margin: spacing.$3,
  },
  offerRow: {
    flexDirection: 'row',
    marginRight: spacing.$2,
  },
  itemContent: {
    alignItems: 'flex-start',
    flexShrink: 1,
    justifyContent: 'center',
    marginLeft: spacing.$3,
  },
  title: {
    marginBottom: spacing.$2,
  },
  badges: {
    flexDirection: 'row',
    marginTop: spacing.$2,
  },
  offerBadge: {
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: spacing.$1,
    height: spacing.$6,
    justifyContent: 'center',
    marginLeft: spacing.$2,
    padding: spacing.$1,
    width: 110,
  },
  offerBadgeText: {
    lineHeight: 14,
  },
});

export const OfferContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.offerContainer, style] });

export const OfferItem = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.offerItem, style] });

export const HeaderBkAndWalmart = ({ style, ...props }: TypographyProps) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return React.createElement(Typography, {
    ...props,
    variant: 'headerOne',
    textAlign: 'center',
    fontSize: 'xl',
    lineHeight: isDesktopLarge ? 36 : undefined,
    style: [styles.headerBkAndWalmart, style],
  });
};

export const HeaderReadySavings = withTypography({
  variant: 'headerOne',
  textAlign: 'center',
  lineHeight: 'md',
  fontSize: '3xl',
  style: styles.headerReadySavings,
});

export const LinkRoyalText = withTypography({
  textAlign: 'left',
  style: styles.linkRoyalText,
});

export const OfferRow = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.offerRow, style] });

export const ItemContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemContent, style] });

export const Title = ({ style, ...props }: TypographyProps) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return React.createElement(Typography, {
    ...props,
    variant: 'headerThree',
    color: getDesignToken('text-default'),
    ellipsizeMode: 'tail',
    fontSize: isDesktopLarge ? 18 : undefined,
    lineHeight: isDesktopLarge ? 22 : undefined,
    numberOfLines: 2,
    style: [styles.title, style],
  });
};

export const Subtitle = withTypography({
  fontSize: 'xs',
  numberOfLines: 2,
  ellipsizeMode: 'tail',
  style: {},
});

export const Badges = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.badges, style] });

export const OfferBadge = ({ children, style, ...props }: OfferBadgeProps) =>
  React.createElement(
    Box,
    { ...props, style: [styles.offerBadge, style] },
    React.createElement(
      Typography,
      { fontSize: 'xs', lineHeight: 'sm', style: styles.offerBadgeText },
      children
    )
  );

export const StyledPicture = Image.withConfig({
  width: '96px',
  height: '96px',
});
